import React, { useMemo } from 'react';
import { Sports } from '@gin-betting/constants';
import type { View } from '@gin-betting/core';

import { Icon } from 'components';
import favorite from 'modules/favorite';
import FixtureData from './FixtureData';
import {
    FixtureDataCS,
    FixtureDataDota,
    FixtureDataFootball,
    FixtureDataIceHockey,
    FixtureDataTennis,
} from './FixtureDataSports';
import useFixtureData from './useFixtureData';

import stream from 'assets/svg/stream.svg';
import './fixtureDataContainer.scss';

const {
    components: { ToggleFavoriteButton },
} = favorite;

interface Props {
    sportEvent: View.Match;
    isStreamAvailable: boolean;
    withDate: boolean;
}

const FixtureContainer: React.FC<Props> = ({
    sportEvent,
    isStreamAvailable,
    withDate,
}) => {
    const { text, subText } = useFixtureData({ sportEvent, withDate });
    const { id: matchId, sportId } = sportEvent;

    const firstIcon = useMemo((): JSX.Element => {
        return <ToggleFavoriteButton matchId={matchId} />;
    }, [matchId]);

    const secondIcon = useMemo((): JSX.Element | null => {
        return isStreamAvailable ? (
            <Icon glyph={stream} styleName="stream" />
        ) : null;
    }, [isStreamAvailable]);

    const fixtureDataSport: { [key: string]: JSX.Element } = {
        [Sports.FOOTBALL]: (
            <FixtureDataFootball
                matchId={matchId}
                firstIcon={firstIcon}
                secondIcon={secondIcon}
                text={text}
                subText={subText}
            />
        ),
        [Sports.ESPORTS_COUNTER_STRIKE]: (
            <FixtureDataCS
                firstIcon={firstIcon}
                secondIcon={secondIcon}
                sportEvent={sportEvent}
                withDate={withDate}
            />
        ),
        [Sports.ESPORTS_DOTA_2]: (
            <FixtureDataDota
                firstIcon={firstIcon}
                secondIcon={secondIcon}
                sportEvent={sportEvent}
                text={text}
                subText={subText}
            />
        ),
        [Sports.ICE_HOCKEY]: (
            <FixtureDataIceHockey
                matchId={matchId}
                firstIcon={firstIcon}
                secondIcon={secondIcon}
                text={text}
                subText={subText}
            />
        ),
        [Sports.TENNIS]: (
            <FixtureDataTennis
                firstIcon={firstIcon}
                secondIcon={secondIcon}
                sportEvent={sportEvent}
                text={text}
            />
        ),
        [Sports.ESPORTS_TENNIS]: (
            <FixtureDataTennis
                firstIcon={firstIcon}
                secondIcon={secondIcon}
                sportEvent={sportEvent}
                text={text}
            />
        ),
    };

    return (
        <div styleName="container">
            {fixtureDataSport[sportId] || (
                <FixtureData
                    firstIcon={firstIcon}
                    secondIcon={secondIcon}
                    text={text}
                    subText={subText}
                />
            )}
        </div>
    );
};

export default FixtureContainer;
